import script from "./escortingaddress.vue?vue&type=script&setup=true&lang=js"
export * from "./escortingaddress.vue?vue&type=script&setup=true&lang=js"

import "./escortingaddress.vue?vue&type=style&index=0&id=0fa9b5ee&scoped=true&lang=css"

import exportComponent from "F:\\proj-abhinav\\meraki\\patient-portal-v3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0fa9b5ee"]])

export default __exports__